import { CardElementData } from '@adyen/adyen-web/dist/types/components/Card/types';
import { useEppoExpEnabled } from './user_hooks';
import eppoFlags from './eppoFlags';
import { AdyenCardOptions, AdyenCardResponse, useLegacyAdyenCard } from './legacy_adyen_card_hook';
import { AdyenCardOptionsV6, AdyenCardResponseV6, useAdyenCardV6 as useV6AdyenCard } from './adyen_card_hook_v6';
import { useAdyenEnvironment } from './adyen_environment_hook';

export interface CardState {
  isValid: boolean; // Specifies if all the information that the shopper provided is valid.
  data: Partial<CardElementData>; // Provides the data that you need to pass in the `/payments` call.
}

export type CSEName =
  | 'encryptedCardNumber'
  | 'encryptedExpiryDate'
  | 'encryptedExpiryMonth'
  | 'encryptedExpiryYear'
  | 'encryptedSecurityCode';

// Shared custom credit card hook (https://docs.adyen.com/payment-methods/cards/custom-card-integration)
export function useAdyenCard(options: AdyenCardOptions | AdyenCardOptionsV6): AdyenCardResponse | AdyenCardResponseV6 {
  const useAdyenV6 = useEppoExpEnabled({ flagKey: eppoFlags.ADYEN_WEB_SIX });
  const { environment, clientKey } = useAdyenEnvironment();

  const v6Result = useV6AdyenCard({ ...(options as AdyenCardOptionsV6), enabled: useAdyenV6, clientKey, environment });
  const legacyResult = useLegacyAdyenCard({ ...(options as AdyenCardOptions), enabled: !useAdyenV6, clientKey, environment });

  return useAdyenV6 ? v6Result : legacyResult;
}
